<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" width="30" height="15" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd"
  fill="#212529" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"/></svg>
</template>
<script lang="ts" setup>

</script>
